import DOMPurify from 'dompurify';
import { cn } from '@/lib/utils';

export type SanitizedHtmlProps = {
  html: string;
  className?: string;
};

/**
 * Renders HTML after DOMPurify sanitization (mitigates XSS from rich-text / CMS content).
 */
export function SanitizedHtml({ html, className }: SanitizedHtmlProps) {
  const safe = DOMPurify.sanitize(html);
  return <div className={cn(className)} dangerouslySetInnerHTML={{ __html: safe }} />;
}
